export default __webpack_public_path__ + "static/media/ClientesIconWhite.47b45b83.svg";